"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsonrpc = require("../jsonrpc");

var _web3Calls = _interopRequireDefault(require("../web3Calls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const WAIT_TIME = 10 * 1000; //10 seconds

const memcache = {
  timestamp: 0,
  blockNumber: 0
};

var _default = async (_ref, res, next) => {
  let payload = _ref.payload,
      requestManager = _ref.requestManager;
  if (payload.method !== 'eth_blockNumber') return next();
  const ethCalls = new _web3Calls.default(requestManager);

  if (memcache.timestamp < new Date().getTime() - WAIT_TIME) {
    try {
      const blockNumber = await ethCalls.getBlockNumber();
      memcache.blockNumber = blockNumber;
      memcache.timestamp = new Date().getTime();
      res(null, (0, _jsonrpc.toPayload)(payload.id, blockNumber));
    } catch (e) {
      res(null, (0, _jsonrpc.toPayload)(payload.id, null));
    }
  } else {
    res(null, (0, _jsonrpc.toPayload)(payload.id, memcache.blockNumber || null));
  }
};

exports.default = _default;